import AdminHome from './AdminHome';
export const adminRoutes = [
    {
      path: '/admin-page',
      name: 'admin-home',
      component: AdminHome,
      meta: {
        requiresAuth: true
      }
    }
]    